export default __webpack_public_path__ + "3d96d42d37e830207a433716e487a251.woff";